import React, { FC } from 'react';
import cls from './Textarea.module.css';
import classNames from 'classnames';

export const Textarea = ({
    title,
    isRequired,
    value,
    onChange,
    name,
    isDisabled = false,
    error = null,
}) => {
    return (
        <div className={classNames(cls.formBlockContent, { [cls.disabled]: isDisabled })}>
            {title && (
                <label className={classNames(cls.modalLabelSelect)}>
                    {title}
                    {isRequired && <span>*</span>}
                </label>
            )}
            <textarea
                name={name}
                onChange={onChange}
                className={classNames(cls.textarea)}
                value={value}
                disabled={isDisabled}
            />
            {error && <span className={classNames(cls.errorMessage)}>{error}</span>}
        </div>
    );
};
